<template>
<!--  登录设备-->
  <div class="login-dev view-box">
    <navBan title="登录设备"></navBan>

    <ul class="device-list">
      <li class="list-item" v-for="(item, index) of loginDeviceList.list" :key="index">
        <div>
          <p>
            <img
              class="device-icon"
              :class="{ 'device-icon--grey': !item.isLocalDevice }"
              :style="!item.isLocalDevice ? { filter: 'grayscale(100%)', opacity: 0.45 } : undefined"
              :src="item.icon"
              alt=""
            ><span class="device-name">{{item.deviceName}}</span>
          </p>
          <p class="text device-info">系统: {{item.deviceOs}}</p>
          <p class="text device-info">登录时间: {{item.loginTime}}</p>
        </div>

        <div>
          <span class="text" v-if="item.isLocalDevice">本机</span>
          <p class="del-btn" @click="changeState(item)" v-else>
            <span class="text">删除</span><img :src="Icons.rightArrowGary" alt="">
          </p>
        </div>
      </li>
    </ul>

    <!--统一安全验证的弹窗-->
    <safeVerify
      ref="safeCheck"
      pageType="h5"
      :checkVisible="checkVisible"
      @updateCheckVisible="updateCheckVisible"
      @handleOperate="handleOperate"
    />
  </div>
</template>

<script setup>
import navBan from '@/components/navBan';
import { onBeforeMount, ref } from 'vue';
import { loginDeviceList, getLoginDevice, delDevice } from '@/utils/setup/loginDevice';
import Icons from '@/assets/images/web';
import safeVerify from '@/components/safeVerify';

const safeCheck = ref('safeCheck');

function changeState (item) {
  safeCheck.value.operateState(item);
}

const checkVisible = ref(false);
function updateCheckVisible (val) {
  checkVisible.value = val;
}

function handleOperate (item) {
  delDevice(item);
}

onBeforeMount(() => {
  getLoginDevice();
});
</script>

<style lang="scss" scoped>
.login-dev {
  overflow: scroll;
  padding:20px 16px 16px;
  .list-item +.list-item {
    margin-top: 16px;
  }
  .device-icon--grey {
    filter: grayscale(100%);
    opacity: 0.6;
  }
}
.ant-btn-primary{
  height: 32px;
}
</style>
